var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"mask"},[_c('div',{staticClass:"loading"})])])}
var staticRenderFns = []

export { render, staticRenderFns }